import { render, staticRenderFns } from "./CustomersLeftRail.vue?vue&type=template&id=708ccffc&scoped=true&"
import script from "./CustomersLeftRail.vue?vue&type=script&lang=js&"
export * from "./CustomersLeftRail.vue?vue&type=script&lang=js&"
import style0 from "./CustomersLeftRail.vue?vue&type=style&index=0&id=708ccffc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708ccffc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VIcon,VList,VListItem})
